<script setup>
import { useTheme } from 'vuetify'

const props = defineProps({
  enabled: { type: Boolean, default: false },
})

defineEmits(['showDeadAnimalOverlay'])

const theme = useTheme()
</script>

<template>
  <v-chip
    class="px-4"
    prepend-icon="mdi-skull-crossbones"
    :append-icon="props.enabled ? 'mdi-check-circle' : undefined"
    variant="elevated"
    :color="props.enabled ? 'primary' : theme.current.value.colors.surface"
    @click="$emit('showDeadAnimalOverlay')"
  >
    {{ $t('canvas.settings.overlay.dead_animals.title') }}
  </v-chip>
</template>
